<div class="card flex justify-content-center">

  <div class="Siderbar">

    <div class="Siderbar__Content">

      <div class="Siderbar__Content__Top">
        <p-card [header]="getTitle()"
          subheader="Selecciona la nueva carpeta para el proceso">
          <ng-template pTemplate="content">
            <div class="card flex justify-content-center">
              <p-tree class="w-full md:w-30rem" selectionMode="single" [(selection)]="selectedFile" [value]="treeNodes"
                (onNodeExpand)="nodeExpand($event)" [loading]="loading"></p-tree>
            </div>
          </ng-template>
        </p-card>
      </div>


      <div class="Siderbar__Content__Footer">

        <button (click)="Move_Process_to_Directorie()" class="btn-icon-text Save">
          <span class="text">Guardar</span>
        </button>

        <button (click)="Cancel_Movement()" class="btn-icon-text Cancel">
          <span class="text">Cancelar</span>
        </button>

      </div>

    </div>

  </div>
</div>
